module.exports = __webpack_public_path__ + "static/media/story_findAndShow.2d8f3069.png";